import React from 'react';

const ItemsByPeriodComponent = ({markers, boName}) => {

    const processReasons = (type, dateField, reasonField) => {
        const reasons = {};

        [...markers].filter(([, marker]) => marker.type === type).forEach(([, marker]) => {
            const description = marker.description;
            const period = findTimeOfDay(description[dateField]);

            const reasonData = description[reasonField];

            if (Array.isArray(reasonData)) {
                reasonData.forEach(reason => {
                    const reasonName = reason.name || reason;
                    reasons[reasonName] = reasons[reasonName] || [0, 0, 0, 0];
                    reasons[reasonName][period] += 1;
                });
            } else {
                reasons[reasonData] = reasons[reasonData] || [0, 0, 0, 0];
                reasons[reasonData][period] += 1;
            }
        });

        return reasons;
    }

    const findTimeOfDay = (date) => {
        date = date.split(' ');
        let time = date[1].split(':');
        let hour = parseInt(time[0]);

        if (hour >= 0 && hour <= 5) {
            return 0;
        } else if (hour >= 6 && hour <= 11) {
            return 1;
        } else if (hour >= 12 && hour <= 17) {
            return 2;
        } else if (hour >= 18 && hour <= 23) {
            return 3;
        }
    }

    const occReasons = processReasons("sentry-occurrence", "dt_ini", "occ_reasons");
    const attendancesReasons = processReasons("dispatch-attendance", "date_start", "nature");
    const bosReasons = processReasons("dispatch-bogcm", "dt_create", "naturesArr");
    const dispatchReasons = processReasons("dispatch-dispatches", "date_start", "nature");

    const reasons = {
        "Ocorr\u00EAncias (Sentry)": occReasons,
        Atendimentos: attendancesReasons,
        [boName]: bosReasons,
        Despachos: dispatchReasons
    };

    const keys = Object.keys(reasons);

    return (
        <div className={"space-y-3"}>
            {
                keys.filter(key => Object.keys(reasons[key]).length).map((key) =>
                    <div key={Math.random().toString()}>
                        <h3 className={"mt-0! mb-0! text-[14px]!"}>{key}</h3>
                        <table className="w-[95%]">
                            <tbody>
                            <tr>
                                <td className="w-53.25 text-[12px]!">
                                    <strong>Natureza</strong>
                                </td>

                                <td className="w-18.75 text-center text-[12px]! py-0.5">
                                    <strong>Madrugada</strong>
                                </td>

                                <td className="w-18.75 text-center text-[12px]! py-0.5">
                                    <strong>Manhã</strong>
                                </td>

                                <td className="w-18.75 text-center text-[12px]! py-0.5">
                                    <strong>Tarde</strong>
                                </td>

                                <td className="w-18.75 text-center text-[12px]! py-0.5">
                                    <strong>Noite</strong>
                                </td>
                            </tr>

                            {Object.entries(reasons[key]).map(([label, values]) => (
                                <tr
                                    key={label}
                                    className="border-b border-[#dcdcdc]"
                                >
                                    <td className="w-53.25 text-[12px]! py-0.5">
                                        {label}
                                    </td>

                                    {values.map((value, index) => (
                                        <td
                                            key={index}
                                            className="w-18.75 text-center text-[12px]! py-0.5"
                                        >
                                            {value}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                )
            }
        </div>
    );
};

export default ItemsByPeriodComponent;